skrilla.directive('promotionDetails',function() {
    return {
        templateUrl: 'directives/promotionDetails/promotionDetails.html',
        scope: {
            promotion:"="
        },
        controller: function($scope, searchService, currencyService, modalService, promotionService, cacheService){
            $scope.validate = {}

            $scope.btagPromotion = $scope.promotion.purpose === 'BTAG_REFERRAL'


            $scope.save = function() {
                if(promotionService.validatePromotion($scope.promotion, $scope.validate)) {
                    modalService.confirm("Are you sure you'd like to update this promotion definition?", function () {
                        const request  = {
                            ...$scope.promotion,
                            ownerAmount : currencyService.multiply($scope.promotion.ownerAmount, $scope.promotion.currency),
                            claimerAmount : currencyService.multiply($scope.promotion.claimerAmount, $scope.promotion.currency)
                        }
                        searchService.put("promotions/definitions/" + $scope.promotion.id, request, "Promotion Successfully updated").then(function (response) {
                            getPromotion();
                        })
                    });
                }
            }

            $scope.updateActive = function(){
                modalService.confirm("Are you sure you want to update this definition?", function(){
                    searchService.put("promotions/definitions/" + $scope.promotion.id + "/active/" + !$scope.promotion.active,  {}, "Promotion successfully updated.").then(function () {
                        $scope.promotion.active = !$scope.promotion.active;
                        getPromotion();
                        if($scope.promotion.purpose === "PROMOTION"){
                            cacheService.getObject("promotionCodesUpdateFn")();
                        }
                    })
                });
            }


            function getPromotion(){
                searchService.get("promotions/definitions/" + $scope.promotion.id).then(function(response){
                    $scope.promotion = response.data;
                    formatPromotion();
                })
            }

            function formatPromotion(){
                $scope.promotion.ownerAmount = currencyService.divide($scope.promotion.ownerAmount, $scope.promotion.currency)
                $scope.promotion.claimerAmount = currencyService.divide($scope.promotion.claimerAmount, $scope.promotion.currency)
                // if($scope.promotion.startAt !== null){
                //     $scope.promotion.startAt =  new Date($scope.promotion.startAt).set
                //
                //
                // }
                // if($scope.promotion.expireAt !== null){
                //     $scope.promotion.expireAt = new Date($scope.promotion.expireAt)
                // }
            }
            formatPromotion();
        }
    };
});
